// extracted by mini-css-extract-plugin
export default {"button":"wAxCBuwj4T_services-landings","extraClickZone":"Z7iBmnhKox_services-landings"};